// REACT
import React, { useMemo } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'

// ANTD
import { Layout } from 'antd'

// UTILS
import { pathLocation } from '../utils/Functions'
import { SegmentNameEnum } from '../utils/Enums'

// COMPONENTS
import TabHeader from '../components/layout/TabHeader'

const { Content, Footer } = Layout

const UnassignedOrders = () => {
    const {pathname} = useLocation()
    const { segment } = useParams()
	const collection = useMemo(() => pathLocation(pathname, 2), [pathname])
	const selectedTab = useMemo(() => SegmentNameEnum?.[`${segment}`]?.name, [segment])

	return (
		<Layout className='WBackground'>
			<TabHeader collection={collection} selectedTab={selectedTab} ></TabHeader>
			<Outlet
                context={{
                    selectedTab,
                    collection,
                }}
            />
		</Layout>
	)
}

export default UnassignedOrders
